import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from './firebase';

/**
 * Clase para manejar las operaciones de almacenamiento en Firebase Storage.
 */
class FirebaseStorageService {
  /**
   * Carga un archivo al almacenamiento de Firebase en la ubicación especificada y devuelve la URL de descarga.
   * @param {string} filePath - La ruta en la que se almacenará el archivo.
   * @param {File} file - El archivo que se cargará en Firebase Storage.
   * @returns {Promise<string>} - La URL de descarga del archivo cargado.
   */
  static async uploadFile(filePath, file) {
    try {
      const storageRef = ref(storage, filePath);
      const snapshot = await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);
      return downloadURL;
    } catch (error) {
      console.error('Error al cargar el archivo:', error);
      throw error;
    }
  }

  /**
   * Descarga un archivo del almacenamiento de Firebase en la ubicación especificada y devuelve la URL de descarga.
   * @param {string} filePath - La ruta del archivo que se desea descargar.
   * @returns {Promise<string>} - La URL de descarga del archivo.
   */
  static async downloadFile(filePath) {
    try {
      const storageRef = ref(storage, filePath);
      const downloadURL = await getDownloadURL(storageRef);
      return downloadURL;
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
      throw error;
    }
  }

  /**
   * Elimina un archivo del almacenamiento de Firebase en la ubicación especificada.
   * @param {string} filePath - La ruta del archivo que se desea eliminar.
   */
  static async deleteFile(filePath) {
    try {
      const storageRef = ref(storage, filePath);
      await deleteObject(storageRef);
    } catch (error) {
      console.error('Error al eliminar el archivo:', error);
      throw error;
    }
  }
}

export default FirebaseStorageService;
